import { cva, type VariantProps } from 'class-variance-authority';
import type { ButtonHTMLAttributes } from 'react';
import { cn } from '../../lib/utils.ts';

const button = cva(
  'inline-flex items-center justify-center gap-1.5 rounded-md text-sm font-medium transition-colors disabled:pointer-events-none disabled:opacity-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand',
  {
    variants: {
      variant: {
        default: 'bg-slate-900 text-white hover:bg-slate-700',
        outline: 'border border-slate-300 bg-white hover:bg-slate-100',
        ghost: 'hover:bg-slate-100',
        danger: 'bg-bad text-white hover:opacity-90',
        /** 공개 화면·고객 셸의 주 버튼 — 랜딩 파랑 */
        live: 'bg-live text-white shadow-[0_10px_24px_-10px_var(--color-live)] hover:-translate-y-px hover:bg-live-hover transition',
      },
      size: { sm: 'h-8 px-3', md: 'h-9 px-4', lg: 'h-12 rounded-xl px-6 text-base font-semibold', icon: 'h-8 w-8' },
    },
    defaultVariants: { variant: 'default', size: 'md' },
  },
);

export function Button({
  className,
  variant,
  size,
  type = 'button',
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & VariantProps<typeof button>) {
  return <button type={type} className={cn(button({ variant, size }), className)} {...props} />;
}
